/**
 * 	TOGGLE ACTION FOR MOBILE READMORE TEAM PAGE
 */
const init = () => {
  jQuery('.read-more').on('click', function (event) {
    jQuery(this).parent().toggleClass('open');
  });
};

export default init;
